import Skeleton from '../../Skeleton';

import { Container } from './styles';

const LoadingLargeCard: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <Skeleton className="bg-skeleton" />
    </Container>
  );
};

export default LoadingLargeCard;
